import { Fonts } from 'components/hato-heart/base-ui'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  column-gap: 12px;
  border-radius: 8px;
  border: 1px solid #eeeeee;
`

const Circle = styled.div`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: #fef1e5;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Number = styled(Fonts.SmallTitleBold)`
  color: ${({ theme }) => theme.colors.primary};
`

const Title = styled(Fonts.SmallTitleMedium)`
  font-size: 14px;
`

const Description = styled(Fonts.SmallTitleRegular)`
  color: ${({ theme }) => theme.colors.darkGrey};
`

export { Wrapper, Circle, Number, Title, Description }
